import { fork, take, call, put, all } from "redux-saga/effects";

import {
  getAllEventsNIITResponse,
  getEventDetailsNIITResponse,
  getSessionNIITListResponse,
  getAllEventsBrokerResponse,
  getEventDetailsBrokerResponse,
  getSessionBrokerListResponse,
  getEnrollBrokerSessionResponse,
  getEnrollAvailabilityResponse,
  getCalendarViewSessionsResponse,
  hostSessionResponse,
  joinSessionResponse,
  getCalendarInstSessionsResponse,
  getCalendarHostSessionsResponse,
  getCalendarSessionListResponse,
  eventNotificationResponse,
  sessionAttendenceResponse,
  checkEventNotificationResponse,
  cancelSessionDataClear,
  cancelSessionDataResponse,
  getAllEventsResponse,
  getMyEventsResponse,
  fetchBoardcastResponse,
  getLiveCalendarSessionListResponse,
  eventTypeListResponse,
  shareImageResponse,
  getLiveSessionListResponse,
  getGlobalSearchEventsResponse,
  syncSessionResponse,
  getEventsTabResponse,
  getAddGroupWorkshopResponse,
  getFileUploadOnAWSResponse,
  getScheduledSessionsResponse,
} from "./actions";
import types from "./types";
import { postAPIWithoutModule, postAPI } from "../../api/generic";
import { onFileUploadAWS } from "../../api/userDetailApi";

export function* doGetAllEventsNIIT() {
  while (true) {
    const { payload } = yield take(types.GET_ALL_EVENTS_NIIT);
    const response = yield call(postAPIWithoutModule, payload, true);
    // console.log("response", response)
    yield put(getAllEventsNIITResponse(response));
  }
}
export function* viewsSessionListNIIT() {
  while (true) {
    const { payload } = yield take(types.SESSION_LIST_NIIT);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getSessionNIITListResponse(response));
  }
}

export function* doGetEventDetailNIIT() {
  while (true) {
    const { payload } = yield take(types.GET_EVENTS_DETAILS_NIIT);
    const response = yield call(postAPIWithoutModule, payload, true);
    yield put(getEventDetailsNIITResponse(response));
  }
}

export function* doGetAllEventsBroker() {
  while (true) {
    const { payload } = yield take(types.GET_ALL_EVENTS_BROKER);
    const response = yield call(postAPIWithoutModule, payload, true);
    // console.log("response", response)
    yield put(getAllEventsBrokerResponse(response));
  }
}
export function* viewsSessionListBroker() {
  while (true) {
    const { payload } = yield take(types.SESSION_LIST_BROKER);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getSessionBrokerListResponse(response));
  }
}

export function* doGetEventDetailBroker() {
  while (true) {
    const { payload } = yield take(types.GET_EVENTS_DETAILS_BROKER);
    const response = yield call(postAPIWithoutModule, payload, true);
    yield put(getEventDetailsBrokerResponse(response));
  }
}

export function* enrollBrokerSessionSaga() {
  while (true) {
    const { payload } = yield take(types.ENROLL_BROKER_SESSION);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getEnrollBrokerSessionResponse(response));
  }
}

export function* doEnrollAvailability() {
  while (true) {
    const { payload } = yield take(types.ENROLL_BROKER_AVAILABILITY);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getEnrollAvailabilityResponse(response));
  }
}
//Calendar
export function* viewCalendarSessionsInfo() {
  while (true) {
    const { payload } = yield take(types.CALENDAR_VIEW_SESSIONS);
    const response = yield all([
      call(postAPIWithoutModule, payload.ecom),
      call(postAPIWithoutModule, payload.broker),
    ]);
    yield put(getCalendarViewSessionsResponse(response));
  }
}

// export function* calendarSessionList() {
//     while (true) {
//         const { payload } = yield take(types.CALENDAR_SESSION_LIST)
//         const response = yield all([
//             call(postAPIWithoutModule, payload.ecom),
//             call(postAPIWithoutModule, payload.broker)
//           ])
//         yield put(getCalendarSessionListResponse(response))
//     }
// }

export function* calendarSessionList() {
  while (true) {
    const { payload } = yield take(types.CALENDAR_SESSION_LIST);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getCalendarSessionListResponse(response));
  }
}

export function* liveCalendarSessionList() {
  while (true) {
    const { payload } = yield take(types.LIVE_CALENDAR_SESSION_LIST);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getLiveCalendarSessionListResponse(response));
  }
}

export function* doEventList() {
  while (true) {
    const { payload } = yield take(types.GET_ALL_EVENTS);
    const response = yield all([
      call(postAPIWithoutModule, payload.ecom),
      call(postAPIWithoutModule, payload.broker),
    ]);
    yield put(getAllEventsResponse(response));
  }
}

export function* doMyEventList() {
  while (true) {
    const { payload } = yield take(types.GET_MY_EVENTS);
    const response = yield all([
      call(postAPIWithoutModule, payload.ecom),
      call(postAPIWithoutModule, payload.broker),
    ]);
    yield put(getMyEventsResponse(response));
  }
}

//Calendar for host Inst
export function* calendarHostSessionsInfo() {
  while (true) {
    const { payload } = yield take(types.CALENDAR_HOST_SESSIONS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getCalendarHostSessionsResponse(response));
  }
}
export function* calendarInstSessionsInfo() {
  while (true) {
    const { payload } = yield take(types.CALENDAR_INSTRUCTOR_SESSIONS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getCalendarInstSessionsResponse(response));
  }
}

export function* createZoomSessionMeeting() {
  while (true) {
    const { payload } = yield take(types.HOST_SESSIONS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(hostSessionResponse(response));
  }
}
export function* joinZoomSessionMeeting() {
  while (true) {
    const { payload } = yield take(types.JOIN_SESSIONS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(joinSessionResponse(response));
  }
}

export function* eventNotification() {
  while (true) {
    const { payload } = yield take(types.EVENT_NOTIFICATION);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(eventNotificationResponse(response));
  }
}

export function* doSessionAttendence() {
  while (true) {
    const { payload } = yield take(types.SESSION_ATTENDANCE);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(sessionAttendenceResponse(response));
  }
}

export function* doCheckNotification() {
  while (true) {
    const { payload } = yield take(types.CHECK_NOTIFICATION);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(checkEventNotificationResponse(response));
  }
}

export function* doSessionCancel() {
  while (true) {
    const { payload } = yield take(types.CANCEL_SESSION);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(cancelSessionDataResponse(response));
  }
}

export function* doGetBoardcastInfo() {
  while (true) {
    const { payload } = yield take(types.FETCH_BOARDCAST);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(fetchBoardcastResponse(response));
  }
}

export function* doGetEventTypeList() {
  while (true) {
    const { payload } = yield take(types.EVENT_TYPE_LIST);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(eventTypeListResponse(response));
  }
}

export function* doShareImage() {
  while (true) {
    const { payload } = yield take(types.SHARE_IMAGE);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(shareImageResponse(response));
  }
}

export function* doGetLiveSessionsList() {
  while (true) {
    const { payload } = yield take(types.LIVE_SESSION_LIST);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getLiveSessionListResponse(response));
  }
}

export function* doGetGlobalSearchEvents() {
  while (true) {
    const { payload } = yield take(types.GLOBAL_SEARCH_EVENTS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getGlobalSearchEventsResponse(response));
  }
}

export function* doGetSessionSync() {
  while (true) {
    const { payload } = yield take(types.SYNC_SESSION_REQ);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(syncSessionResponse(response));
  }
}

export function* doGetEventsTabData() {
  while (true) {
    const { payload } = yield take(types.NEW_EVENTS_TAB);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getEventsTabResponse(response));
  }
}

export function* doAddGroupWorkshop() {
  while (true) {
    const { payload } = yield take(types.ADD_GROUP_WORKSHOP);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getAddGroupWorkshopResponse(response));
  }
}

export function* doUploadFileOnAWS() {
  while (true) {
    const { payload } = yield take(types.FILE_UPLOAD_ON_AWS);
    const response = yield call(onFileUploadAWS, payload);
    yield put(getFileUploadOnAWSResponse(response));
  }
}

export function* doGetScheduledSessions() {
  while (true) {
    const { payload } = yield take(types.SCHEDULED_SESSIONS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getScheduledSessionsResponse(response));
  }
}

function* allEvents() {
  yield fork(doGetAllEventsNIIT);
  yield fork(viewsSessionListNIIT);
  yield fork(doGetEventDetailNIIT);
  yield fork(doGetAllEventsBroker);
  yield fork(viewsSessionListBroker);
  yield fork(doGetEventDetailBroker);
  yield fork(enrollBrokerSessionSaga);
  yield fork(doEnrollAvailability);
  yield fork(viewCalendarSessionsInfo);
  yield fork(calendarSessionList);
  yield fork(liveCalendarSessionList);
  yield fork(calendarHostSessionsInfo);
  yield fork(calendarInstSessionsInfo);
  yield fork(createZoomSessionMeeting);
  yield fork(joinZoomSessionMeeting);
  yield fork(eventNotification);
  yield fork(doSessionAttendence);
  yield fork(doCheckNotification);
  yield fork(doSessionCancel);
  yield fork(doEventList);
  yield fork(doMyEventList);
  yield fork(doGetBoardcastInfo);
  yield fork(doGetEventTypeList);
  yield fork(doShareImage);
  yield fork(doGetLiveSessionsList);
  yield fork(doGetGlobalSearchEvents);
  yield fork(doGetSessionSync);
  yield fork(doGetEventsTabData);
  yield fork(doAddGroupWorkshop);
  yield fork(doUploadFileOnAWS);
  yield fork(doGetScheduledSessions);
}

export default allEvents;
